import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { TimeBasedSettingForSpecificCallerRequest } from '../api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerrequest';
import { TimeBasedSettingForSpecificCallerResponse, TimeBasedSettingForSpecificCallerResponseDtoImpl } from '../api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class TimeBasedSettingForSpecificCallerAPIProcessorImpl extends SixdeeCRBTAPIProcessor<TimeBasedSettingForSpecificCallerRequest, TimeBasedSettingForSpecificCallerResponse>
{
    execute(request: TimeBasedSettingForSpecificCallerRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new TimeBasedSettingForSpecificCallerResponseDtoImpl(APIFeatures.TIME_BASED_SETTING_FOR_SPECIFIC_CALLER, "Time Based Setting for Specific Caller Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new TimeBasedSettingForSpecificCallerResponseDtoImpl(APIFeatures.TIME_BASED_SETTING_FOR_SPECIFIC_CALLER, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
    
            this.getAPIFailure(new TimeBasedSettingForSpecificCallerResponseDtoImpl(APIFeatures.TIME_BASED_SETTING_FOR_SPECIFIC_CALLER, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/timebasedsettingforspecificcallerapiprocessor.tsx